<!-- 图像检索 -->
<template>
  <div class="page-container common-blue-contain bg-contain">
    <div class="search-container search">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item :label="$t('serialNumberP2')">
          <el-input v-model="searchForm.helmetId" clearable :placeholder="$t('serialNumberP2')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('profile')">
          <el-select v-model="searchForm.type" clearable :placeholder="$t('profile')" :popper-append-to-body="false">
            <el-option :label="$t('video')" value="1"></el-option>
            <el-option :label="$t('picture')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('analysis')" class="analy">
          <el-input
            v-model="searchForm.keyword"
            :placeholder="$t('imageRetrievalTip')"
            clearable
            @clear="clearFile"
            @input="clearFile"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-camera-solid "
              style="cursor: pointer;"
              title="点击上传查询"
              @click="setFile"
            >
              <input type="file" ref="fileInputRef" style="display: none" accept="image/png,image/jpeg,image/jpg" /> </i
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Recordtime')" class="datetime">
          <el-date-picker
            v-model="searchForm.logTimestampBegin"
            :placeholder="$t('startDate')"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            popper-class="date-picker-blue-hw"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('TO')" class="datetime">
          <el-date-picker
            v-model="searchForm.logTimestampEnd"
            :placeholder="$t('endDate')"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 23:59:59"
            popper-class="date-picker-blue-hw"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <transition name="el-zoom-in-center">
      <div class="content" v-if="data.length > 0" v-loading="loading" element-loading-text="拼命加载中">
        <div class="one-line">
          <div class="tag">
            <div class="title">
              <span class="type-tag"></span>
              <span class="type-line"></span>
            </div>
            <div class="medias">
              <ul>
                <li v-for="(d, index2) in data" :key="index2">
                  <!-- 图片 -->
                  <div v-if="d.type === 2" class="picture">
                    <div class="box">
                      <el-image
                        :src="d.mediaUrl"
                        :title="d.location"
                        class="pic"
                        :lazy="true"
                        :preview-src-list="[d.mediaUrl]"
                      >
                      </el-image>
                    </div>
                    <div class="pic_contrl">
                      <div class="flex_just_between lh20">
                        <h5 class="video-time-pic">
                          <span>{{ d.userName }}-{{ d.helmetId }}</span>
                          <span>{{ d.logTimestamp }}</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div v-if="d.type === 1" class="picture video">
                    <!-- 通过首个存在视频的关键词控制视频播放窗口只渲染一个 -->
                    <div class="exVideo" v-if="videoShow && d.detectId === firstDetectId">
                      <vue-draggable-resizable
                        :w="520"
                        :h="385"
                        :x="100"
                        :y="100"
                        :min-width="350"
                        :min-height="250"
                        :parent="false"
                        :grid="[10, 10]"
                        id="amplifyVideo"
                        class-name="dragging1"
                        @dragging="onDrag"
                        @resizing="onResize"
                        :draggable="allowDrag"
                      >
                        <div class="exVideoTitle">
                          <span>{{ $t('History') }}</span>
                          <i class="sys-close-btn" @click="cancleVideoShow"></i>
                        </div>
                        <div>
                          <HistoryVideo
                            :videoSrcArr="playVideoData"
                            :index.sync="videoIndex"
                            :videoShow.sync="videoShow"
                            :userData="historyData"
                            :showPrevNext="false"
                            :allowDrag.sync="allowDrag"
                          >
                          </HistoryVideo>
                        </div>
                      </vue-draggable-resizable>
                    </div>
                    <div class="box">
                      <!-- 已删除 -->
                      <div class="delete" v-if="d.status === 1">
                        <img class="upper" src="@/icon/monitor/delete.png" />
                        <h5 class="upper-text">{{ $t('Deleted') }}</h5>
                      </div>
                      <!-- 未上传 -->
                      <div v-else-if="!d.uploadFlag">
                        <img class="upper" src="@/icon/monitor/notUploaded.png" />
                        <h5 class="upper-text">{{ $t('NotUploaded') }}</h5>
                      </div>
                      <!-- 正常 -->
                      <el-image
                        v-else
                        :src="
                          !d.preMediaUrl
                            ? require(theme === 'default'
                                ? '@/icon/monitor/coverPlaceLight.png'
                                : '@/icon/monitor/coverPlaceDark.png')
                            : d.preMediaUrl
                        "
                        @click="playVideo(d)"
                        class="pic"
                        :lazy="true"
                      >
                        <div slot="placeholder" class="image-slot">
                          <img class="place-img" :src="d.preMediaUrl" />
                        </div>
                      </el-image>
                    </div>
                    <div class="pic_contrl">
                      <div class="flex_just_between lh20">
                        <h5 class="video-time-pic">
                          <span>{{ d.userName }}-{{ d.helmetId }}</span>
                          <span>{{ d.logTimestamp }}~{{ d.endTimestamp }}</span>
                        </h5>
                      </div>
                    </div>
                    <img
                      v-if="d.status === 0 && d.uploadFlag"
                      @click="playVideo(d)"
                      class="center"
                      src="@/icon/monitor/videoPlay.png"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content"
        v-else
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="text-align: center;padding-top: 20px;"
      >
        {{ loading ? '' : '暂无数据' }}
      </div>
    </transition>
  </div>
</template>

<script>
import HistoryVideo from '@/components/new-historyVideo/Index.vue'
import { downloadPic } from '@/api/log/mediaTag'
import { findAnalyseMediaList } from '@/api/imageRetrieval'
import { mapGetters } from 'vuex'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
export default {
  name: 'imageRetrieval',
  data() {
    return {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      allowDrag: true,
      searchForm: {
        type: '', // 2:图片 1:视频
        helmetId: '', // 头盔ID
        logTimestampBegin: '', // 开始日期
        logTimestampEnd: '', // 结束日期
        keyword: '', //关键词
      },
      // 是否显示 预览图片
      imgShow: false,
      // 播放器开关
      videoShow: false,
      // 首个视频特征id
      firstDetectId: '',
      videoIndex: null,
      playVideoData: [],
      historyData: {},
      imageList: [],
      data: [],
      loading: false,
      theme: localStorage.getItem('theme'),
    }
  },
  components: {
    HistoryVideo,
    VueDraggableResizable,
  },
  computed: {
    ...mapGetters(['isCloud', 'isDefaultTheme']),
    // 计算图片预览组件的预览图数组
    previewImgList() {
      return this.imageList.map(i => {
        return i.mediaUrl
      })
    },
  },
  watch: {},
  methods: {
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function(x, y) {
      console.log(x, y)
      this.x = x
      this.y = y
    },
    // 查询数据
    getPageData() {
      this.data = []
      this.loading = true
      let queryParams = new FormData()
      let files = this.$refs.fileInputRef.files
      if (files && files.length > 0) {
        queryParams.append('featureImage', files[0])
        queryParams.append('keyword', '')
      } else {
        queryParams.append('featureImage', '')
        queryParams.append('keyword', this.searchForm.keyword)
      }
      // this.searchForm.logTimestampBegin判空
      if (this.searchForm.logTimestampBegin && this.searchForm.logTimestampBegin !== 'null') {
        queryParams.append('logTimestampBegin', this.searchForm.logTimestampBegin)
      } else {
        queryParams.append('logTimestampBegin', '')
      }
      // this.searchForm.logTimestampEnd判空
      if (this.searchForm.logTimestampEnd && this.searchForm.logTimestampEnd !== 'null') {
        queryParams.append('logTimestampEnd', this.searchForm.logTimestampEnd)
      } else {
        queryParams.append('logTimestampEnd', '')
      }
      queryParams.append('type', this.searchForm.type)
      queryParams.append('helmetId', this.searchForm.helmetId)
      findAnalyseMediaList(queryParams).then(res => {
        this.loading = false
        if (res.state === 0) {
          // 判断res.value不为空后遍历res.value，获取第一个视频的数据
          if (res.value && res.value.length > 0) {
            this.data = res.value
            res.value.forEach(item => {
              if (item.type === 1) {
                this.firstDetectId = item.detectId
                this.data = res.value
                return
              }
            })
          }
        }
      })
    },
    // 下载图片
    download(path, name) {
      downloadPic(path, name).then(res => {
        this.downFile(name, res)
      })
    },
    // 下载文件
    downFile(file_name, content) {
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, file_name)
      }
      // for Non-IE (chrome, firefox etc.)
      else {
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = file_name
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    // 选择图片文件
    setFile(item) {
      // 触发文件选择
      this.$refs.fileInputRef.click()
      // 文件改变后获取文件名
      this.$refs.fileInputRef.onchange = () => {
        let files = this.$refs.fileInputRef.files
        if (files && files.length > 0) {
          this.searchForm.keyword = files[0].name
        }
      }
    },
    // 清空图片文件
    clearFile() {
      this.$refs.fileInputRef.value = ''
    },
    // 关闭视频播放
    cancleVideoShow() {
      this.videoShow = false
    },
    // 播放视频
    playVideo(mediaData) {
      let videoList = []
      console.log(mediaData)
      videoList.push(JSON.parse(JSON.stringify(mediaData)))
      // 深拷贝赋值
      this.playVideoData = videoList
      console.log(this.playVideoData)
      this.videoIndex = 0
      this.videoShow = true
    },
  },
  mounted() {
    this.getPageData()
  },
  created() {},
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.page-container {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: auto;
  background-color: #EEF5FE;

  .search-container {
    margin: 20px 30px 0px 30px;
    // width: 93%;
  }
  .content {
    position: absolute;
    top: 60px;
    left: 30px;
    right: 30px;
    bottom: 10px;
    font-size: 20px;
    color: #333;
    .tags {
      height: 32.8%;
    }
    .tag {
      height: 100%;
    }
    .title {
      position: relative;
      .type-tag {
        position:relative;
        display:inline-block;
        // width: 100%
        height: 36px;
        line-height: 36px;
        color: #0e65dd;
        font-weight: bold;
        font-size: 20px;
      }
      .type-line {
        position:absolute;
        background:#ccc;
        content:"";
        height:1px;
        top:50%;
        width: 100%;
        border-top: 1px solid #66b1ff;
      }
    }
    .medias{
      height: calc(100% - 40px);
      ul {
        height 100%
        overflow-y auto
        li {
          width 19.3%
          height 97%
          position relative
          margin-left 15px
          float left
          cursor default
          .picture {
            width 100%
            height: 100%;
            position relative
            .box {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              border: 0.1px solid #00a0e9;
              .pic {
                width: 100%;
                height: 100%;
                cursor: pointer;
                border-radius: 4px;
                -o-object-fit: fill;
                object-fit: fill;
              }
            }
            .pic_contrl {
              width: 100%;
              position: absolute;
              bottom: 5px;
              left: 1px;
              background rgba(0, 0, 0,0.6)
              .video-time-pic {
                width: 100%;
                height: 32px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size 12px
                font-weight 400
                color #fff
                line-height: 16px;
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                  span {
                    margin-left 9px
                    font-size 12px
                  }
              }
            }
            .center {
              position absolute
              top 50%
              left 50%
              transform translate(-50%,-50%)
              width 40px
              heigth 40px
              cursor: pointer
            }
          }
          .video {
            .video-time-pic {
              height: 52px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size 12px
              font-weight 400
              color #fff
              line-height: 16px;
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap
              }
              .exVideo {
                background #fff
                position fixed
                border: 1px solid rgba(0, 222, 255, 0.5);
                z-index: 999
                #amplifyVideo {
                  pointer-events: auto
                  background #fff
                  position fixed
                  left: 30%
                  top: 20%
                  width 520px
                  // height 400px
                  border: 1px solid rgba(0, 222, 255, 0.5)
                  z-index: 9999
                }
                .exVideoTitle {
                  color #0E65DD
                  display flex
                  justify-content: space-between;
                  align-items: center;
                  background url('~@/icon/newBg/img_head1.png') no-repeat
                  background-size 100% 39px
                  padding-left 50px
                  line-height 39px
                  span {
                    font-size: 18px;
                    font-weight: bold;
                  }
                  .sys-close-btn {
                    margin-right 5px
                  }
                }
              }
          }

        }
        li:nth-child(5n+1) {
          margin-left 0
        }
      }
    }
    .two-line {
      height: 48%
      .medias ul li {
        height: 60%
        margin-bottom: 20px
      }
    }
    .one-line {
      height: 99%
      .medias ul li {
        height: 30%
        margin-bottom: 20px
      }
    }
  }
}
::-webkit-scrollbar
  width 6px
  height 6px
  background-color #EBEBEB
// 滚动条里面可以拖动的那部分
::-webkit-scrollbar-thumb
  border-radius 4px
  background-color #9f9d9d
  width 20px !important
// 深色样式
.theme-dark {
  .page-container {
    background-color: #001143;
    .content {
      .medias{
        ul {
          li {
            .video {
              #amplifyVideo {
                background #041d5d
              }
              .exVideoTitle {
                color #00E4FF
                background url('~@/icon/newBg/img_head1-m.png') no-repeat
              }
            }
          }
        }
      }
    }

    .li-container {
      background: rgba(#002A96, 0.8);


      .li-title {
        background-image: url('~@/icon/focus/ic_headimg.png');
        color: #00E4FF;
      }

      .el-icon-edit {
        color: #00deff;
      }

      .no-tips {
        color: rgba(255, 255, 255, 0.5);
      }

      .vedio-label {
        color: #fff;
      }

      .gps-box {
        ul {
          li {
            border-bottom: 1px solid #2A5CBA;
            .gps-li {
              .label-box {
                h5 {
                  color: #00DEFF;
                }

                p {
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  .important-img {
    .img-title {
      color: #fff;
      border: 1px solid #00DEFF;

      .name {
        color: #fff;
      }
    }
  }
}
/deep/.analy {  .el-input__inner {
    padding: 12px 20px 12px 30px !important;
  }
}
.search .el-form .el-form-item:last-child {
  margin-top: 0 !important;
}
</style>
